<h3 translate class="text-center">TOP_PRODUCTS</h3>

<lib-filter-list [configService]="topProductListConfig"></lib-filter-list>
